import React, { useEffect, useState } from "react";
import translate from "../../../i18n/translate";
import { useHistory } from "react-router-dom";
import Message from "../../common/Message";
import TextFieldGroup from "../../common/TextFieldGroup";
import BackNav from "../../common/BankNav";
import { connect } from "react-redux";
import ApiRequest from "../../../actions/ApiRequest";
import { getAllCompanies } from "../../../actions/companiesAction";
import ProvidersCards from "../../../core/containers/ProvidersCards/ProvidersCards.jsx";
import { checkNumberProvider } from "../../../shared/utils/ppUtils.js";
import AmountCard from "../../../core/core-components/AmountCard/AmountCard.jsx";
import { useMount } from "shared/hooks/ppHooks";

const OoredooInputNu = ({
  isDarktheme,
  allCompanies,
  loading,
  getAllCompanies,
}) => {
  useMount(() => {
    document.title = "Ooredoo | Phone Play";
    getAllCompanies();
  }, []);

  const history = useHistory();
  const provider_Id = history.location.state?.provider_id;
  const passedMobileNumber = history.location.state?.mobileNumber;

  const [value, setValue] = useState(passedMobileNumber || "");
  const [isEmpty, setIsEmpty] = useState(false);
  const [showData, setShowData] = useState(false);
  const [currentNumber, setCurrentNumber] = useState(null);

  const getdata = async (mobileNumber) => {
    try {
      const { data } = await ApiRequest.post(
        `number_provider?number=${mobileNumber}`
      );
      setCurrentNumber(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (passedMobileNumber && passedMobileNumber?.trim()?.length === 10) {
      checkNumberProvider(passedMobileNumber, setCurrentNumber, setShowData);
    }
  }, [passedMobileNumber]);

  const onSubmit = (e) => {
    e.preventDefault();

    if (
      value === undefined ||
      value.split("").length < 10 ||
      value.split("").length > 10
    ) {
      setIsEmpty(true);
    } else {
      setIsEmpty(false);
      sessionStorage.removeItem("ooredoo3g");
      sessionStorage.removeItem("ooredooMin");
      sessionStorage.removeItem("ooredooCredit");
      sessionStorage.removeItem("ooredooRom");
      sessionStorage.removeItem("ooredooSuper");
      history.push(`/company/ooredoo/credit/${value}`);
    }
  };

  const handelChangeNumber = (event) => {
    console.log('🔵 Ooredoo handelChangeNumber called!', event.target.value);
    const newValue = event.target.value;
    setValue(newValue);
    
    // Dispatch custom event to notify RightSideBar of phone number change
    console.log('📤 Ooredoo dispatching phone number event:', newValue);
    const customEvent = new CustomEvent('phoneNumberInputChange', {
      detail: { phoneNumber: newValue }
    });
    window.dispatchEvent(customEvent);
    console.log('✅ Event dispatched successfully');
    
    if (newValue.split("").length === 10) {
      setShowData(true);
      getdata(newValue);
    }
  };

  return (
    <>
      <div>
        <div className="card card-home ooredoo">
          <div className={isDarktheme ? "Company_Dark_Nav" : "Company_Nav"}>
            <BackNav title="Ooredoo" />
            <img
              className="Hot_Nav_Logo"
              style={{ width: "100px" }}
              alt="jawwal"
              src="https://w7.pngwing.com/pngs/915/1017/png-transparent-ooredoo-kuwait-telecommunication-ooredoo-shop-internet-monogram.png"
            />
          </div>
        </div>
        <form className="my-5 text-Continer" onSubmit={onSubmit}>
          {isEmpty && <Message msg="Enter valid number" />}
          <div className="form-group row">
            <div className="col-12 col-md-7 d-flex">
              <label
                htmlFor="inputEmail3"
                className="col-3 col-form-label"
                style={
                  !isDarktheme
                    ? { fontSize: "1.6rem", minWidth: 160 }
                    : { fontSize: "1.6rem", minWidth: 160, color: "white" }
                }
              >
                {translate("jawwalNo")}
              </label>
              <TextFieldGroup
                name={"mobileNumber"}
                value={value}
                onChange={handelChangeNumber}
                onInput={handelChangeNumber}
                type="number"
                autoFocus={true}
              />
            </div>
            <div className="col-3 col-md-2">
              <button
                style={{ width: "110%", minHeight: "55px" }}
                type="submit"
                className="btn sign-but p-2 w-30"
                onSubmit={onSubmit}
              >
                {translate("next")}
              </button>
            </div>
          </div>
        </form>

        {showData && currentNumber?.provider !== "unknown" ? (
          <div
            className={
              isDarktheme &&
              currentNumber?.provider?.toLowerCase() ===
                translate("ooredoo")?.props?.id?.toLowerCase()
                ? "Company_Container_Dark"
                : isDarktheme &&
                  currentNumber?.provider?.toLowerCase() !==
                    translate()?.props?.id?.toLowerCase()
                ? "Company_Container_Red"
                : !isDarktheme &&
                  currentNumber?.provider?.toLowerCase() ===
                    translate("ooredoo")?.props?.id?.toLowerCase()
                ? "Company_Container_white_green"
                : !isDarktheme &&
                  currentNumber?.provider?.toLowerCase() !==
                    translate("ooredoo")?.props?.id?.toLowerCase()
                ? "Company_Container_white_Red"
                : "Company_Container"
            }
          >
            <div
              className="img__wrap"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <img
                src={currentNumber?.provider_logo}
                alt={currentNumber?.provider}
                className="Company_Logo"
              />
              {currentNumber?.pci_url === "N/A" ? (
                <span style={{ width: 140, height: 60 }}>
                  <AmountCard amount={currentNumber?.amount} />
                </span>
              ) : (
                <img
                  src={currentNumber?.pci_url}
                  alt={currentNumber?.pci}
                  className="Company_Logo"
                />
              )}
              <p
                className={
                  isDarktheme
                    ? "Company_Provider_Dark img__description"
                    : "Company_Provider img__description"
                }
              >
                {currentNumber?.pci}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "70%",
              }}
            >
              <p
                className={
                  isDarktheme ? "Company_Provider_Dark" : "Company_Provider"
                }
              >
                {currentNumber?.provider}
              </p>
              <p
                className={
                  isDarktheme ? "Company_Provider_Dark" : "Company_Provider"
                }
                style={{ paddingRight: "25px" }}
              >
                {currentNumber?.amount}₪
              </p>
            </div>
          </div>
        ) : (
          <></>
        )}
        {showData &&
        currentNumber?.provider !== "unknown" &&
        !(
          currentNumber?.provider?.toLocaleLowerCase() ===
          translate("ooredoo").props.id.toLowerCase()
        ) ? (
          <>
            <div className="attention_pay_div_container">
              <p className="Company_Provider_Error">
                {translate("Attention_Pay")}
              </p>
            </div>
          </>
        ) : null}
        <div className="logo_Container">
          <ProvidersCards currentProviderId={provider_Id} />
        </div>
      </div>
    </>
  );
};
const mapStateToProps = ({
  darkTheme: { isDarktheme },
  companies: { allCompanies, loading },
}) => ({
  isDarktheme,
  allCompanies,
  loading,
});
export default connect(mapStateToProps, { getAllCompanies })(OoredooInputNu);
